import React from "react";
import { App } from "../../../../routes/Constants";
import ViewPAF from "../../../common/ViewPAF/ViewPAF";

/** Renew banner, error line, ViewPAF + footer. Pharmacy gets full edit props; others get tracker-only (legacy split). */
export function PafFormScrollBody({
  findProduct,
  storageData,
  navigate,
  errorMessage,
  latestPafId,
  isPharmacy,
  historyPafSummaries,
  detailsSelectedPAF,
  userInfo,
  viewPafPharmacyProps,
  viewPafDefaultProps,
  footer,
}) {
  return (
    <>
      <div
        className="wrapper-flex custom-style"
        data-testid="paf-page-scroll-body"
      >
        {findProduct?.can_renew_registration === false && (
          <div
            className="mb-4 flex"
            data-testid="paf-page-renew-registration-banner"
          >
            <span className="red-label">
              Please renew your registration for{" "}
              <span className="red-label bold">
                {findProduct?.product_name}
              </span>
              .
            </span>
            <button
              className="red-button"
              data-testid="paf-page-renew-registration-button"
              onClick={() =>
                navigate(
                  App.PROFILE_DEFAULT + storageData?.registration_number
                )
              }
            >
              Renew Registration
            </button>
          </div>
        )}
      </div>
      <div className="red-label" data-testid="paf-page-error-message">
        {errorMessage}
      </div>
      {latestPafId &&
        (isPharmacy ? (
          <ViewPAF
            historyPafs={historyPafSummaries}
            receivedForm={detailsSelectedPAF(latestPafId)}
            patientDetails={userInfo}
            footer={footer}
            {...viewPafPharmacyProps}
            {...viewPafDefaultProps}
          />
        ) : (
          <ViewPAF
            historyPafs={historyPafSummaries}
            receivedForm={detailsSelectedPAF(latestPafId)}
            patientDetails={userInfo}
            footer={footer}
            {...viewPafDefaultProps}
          />
        ))}
    </>
  );
}
